import React from 'react';
import { TileLayer } from 'react-leaflet';
import { RootState } from '../../store';
import { useAppSelector } from './mapSlice';
import { getBaseLayer } from '../../config/mapLayers';

/**
 * Renders every enabled base layer as a stacked Leaflet `TileLayer`.
 *
 * The layer order in `state.mapUi.baseLayers` is top-to-bottom, so the first
 * entry gets the highest z-index and is drawn on top. Each layer's opacity is
 * applied independently, which lets the operator blend sources (e.g. a
 * semi-transparent satellite layer over OSM).
 */
export default function BaseLayers() {
    const layers = useAppSelector((state: RootState) => state.mapUi.baseLayers);

    return (
        <>
            {layers.map((layer, index) => {
                if (!layer.visible) return null;
                const def = getBaseLayer(layer.id);
                if (!def) return null;
                return (
                    <TileLayer
                        key={layer.id}
                        url={def.url}
                        attribution={def.attribution}
                        maxZoom={def.maxZoom}
                        opacity={layer.opacity}
                        // Higher z-index = drawn on top; index 0 is the topmost layer.
                        zIndex={layers.length - index}
                    />
                );
            })}
        </>
    );
}
